import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';


import { UserService } from 'src/app/Services/user-service';
import { SubProductsDto } from 'src/app/models';


@Component({
  selector: 'app-sub-products',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ],
  templateUrl: './sub-products.component.html',
  styleUrls: ['./sub-products.component.scss']
})
export class SubProductsComponent implements OnInit {

  subdatasetCollections;
  isLoadingResults = true;
  private positionRelativeToElement: ElementRef;

  constructor(private userService : UserService,
    public dialogRef: MatDialogRef<SubProductsComponent>,
    @Inject(MAT_DIALOG_DATA) public options: { positionRelativeToElement: ElementRef }) {
      this.positionRelativeToElement = options.positionRelativeToElement;
  }

  ngOnInit(): void {

    this.userService.getSubProducts().subscribe((subproducts) => {
      this.isLoadingResults = false;
      this.subdatasetCollections = subproducts;
    });
    const matDialogConfig = new MatDialogConfig()
    const rect: DOMRect = this.positionRelativeToElement.nativeElement.getBoundingClientRect()

    matDialogConfig.position = { right: `1px`, top: `${rect.bottom + 2}px` }
    this.dialogRef.updatePosition(matDialogConfig.position)
  }

}
